import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, ButtonGroup, Spinner, FormGroup, Label, Input } from 'reactstrap';
import ImageMapper from '../ImageMapper/imageMapper';
import Axios from '../../apis/nodeServer';
import { fetchFloors } from '../../actions';
import { withTranslation } from 'react-i18next';
import './riskHeatMap.css';

class RiskHeatMap extends Component {
    state = {
        floorId: null,
        floorPlanImage: null,
        floorPlanWidth: 856,
        areas: [],
        riskType: 'total',
        periodDays: 90,
        loading: false,
        selectedArea: null,
        hoveredArea: null,
        error: null,
        mockFloors: [],
        containerWidth: null
    };

    componentDidMount() {
        this._isMounted = true;
        this.timeouts = [];
        this.props.fetchFloors();

        const measureContainer = () => {
            if (this.containerRef && this._isMounted) {
                const width = this.containerRef.offsetWidth;
                if (width > 0) {
                    this.setState({ containerWidth: width });
                } else {
                    setTimeout(measureContainer, 100);
                }
            }
        };

        setTimeout(measureContainer, 200);

        if (window.ResizeObserver) {
            this.resizeObserver = new ResizeObserver(() => {
                if (this.containerRef && this._isMounted) {
                    this.setState({ containerWidth: this.containerRef.offsetWidth });
                }
            });
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
        // Limpar todos os timeouts
        if (this.timeouts) {
            this.timeouts.forEach(timeout => clearTimeout(timeout));
            this.timeouts = [];
        }
        if (this.mockDataTimeout) {
            clearTimeout(this.mockDataTimeout);
        }
        if (this.forceMockTimeout) {
            clearTimeout(this.forceMockTimeout);
        }
        if (this.updateTimeout) {
            clearTimeout(this.updateTimeout);
        }
        if (this.filterTimeout) {
            clearTimeout(this.filterTimeout);
        }
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.floorsList && prevProps.floorsList !== this.props.floorsList && this.props.floorsList.length > 0) {
            if (this.updateTimeout) {
                clearTimeout(this.updateTimeout);
            }
            this.setState({ floorId: this.props.floorsList[0].id }, () => {
                if (this._isMounted) {
                    this.loadHeatMapData();
                    if (this.props.onFloorChange) {
                        this.props.onFloorChange(this.state.floorId);
                    }
                }
            });
        }

        if (prevState.floorId !== this.state.floorId && this.state.floorId !== null) {
            this.loadHeatMapData();
        }
    }

    generateMockData = () => {
        console.log('📊 Generating mock risk data with DETAILED floor plan...');

        // Generate mock floors for dropdown
        const mockFloors = [
            { id: 'mock-floor-1', floor_name: 'Floor 1 - Microbiologia', building: { building_name: 'Main Lab' } },
            { id: 'mock-floor-2', floor_name: 'Floor 2 - Bioquímica', building: { building_name: 'Main Lab' } },
            { id: 'mock-floor-3', floor_name: 'Floor 3 - Patologia', building: { building_name: 'Main Lab' } }
        ];

        const mockAreas = [
            // Sala de Diluição (Norte) - 2 pontos
            { id: 1, shape: 'circle', coords: [173, 144, 35], name: 'Sala de Diluição', text: 'CABINE DILUIÇÃO 1583', risk_score: 85, risk_level: 'Critical', contamination_count: 12, pathogen_types: { 'Aeróbios Mesófilos': 12 } },
            { id: 2, shape: 'circle', coords: [333, 180, 30], name: 'Sala de Diluição', text: 'FLUXO 0026', risk_score: 72, risk_level: 'High', contamination_count: 9, pathogen_types: { 'Aeróbios Mesófilos': 9 } },

            // Sala de Leitura - 2 pontos
            { id: 3, shape: 'circle', coords: [1030, 144, 25], name: 'Sala de Leitura', text: 'BANCADA BIOQUÍMICA', risk_score: 55, risk_level: 'Medium', contamination_count: 5, pathogen_types: { 'Aeróbios Mesófilos': 5 } },
            { id: 4, shape: 'circle', coords: [1190, 180, 30], name: 'Sala de Leitura', text: 'ESTUFA ANÁLISE', risk_score: 68, risk_level: 'High', contamination_count: 7, pathogen_types: { 'Aeróbios Mesófilos': 7 } },

            // Sala de Pesagem (Centro) - 2 pontos
            { id: 5, shape: 'circle', coords: [633, 309, 23], name: 'Sala de Pesagem', text: 'BANCADA PESAGEM 1', risk_score: 42, risk_level: 'Medium', contamination_count: 4, pathogen_types: { 'Aeróbios Mesófilos': 4 } },
            { id: 10, shape: 'circle', coords: [767, 329, 23], name: 'Sala de Pesagem', text: 'BALANÇA PRECISÃO', risk_score: 48, risk_level: 'Medium', contamination_count: 5, pathogen_types: { 'Aeróbios Mesófilos': 5 } },

            // Sala de Diluição (Sul) - 2 pontos
            { id: 6, shape: 'circle', coords: [173, 456, 23], name: 'Sala de Diluição', text: 'CABINE DILUIÇÃO 684', risk_score: 38, risk_level: 'Medium', contamination_count: 3, pathogen_types: { 'Aeróbios Mesófilos': 3 } },
            { id: 7, shape: 'circle', coords: [333, 480, 33], name: 'Sala de Diluição', text: 'FLUXO 1378', risk_score: 75, risk_level: 'High', contamination_count: 8, pathogen_types: { 'Aeróbios Mesófilos': 8 } },

            // Sala de Identificação - 2 pontos
            { id: 8, shape: 'circle', coords: [1030, 456, 20], name: 'Sala de Identificação', text: 'BANCADA IDENTIFICAÇÃO', risk_score: 25, risk_level: 'Low', contamination_count: 2, pathogen_types: { 'Aeróbios Mesófilos': 2 } },
            { id: 9, shape: 'circle', coords: [1190, 480, 23], name: 'Sala de Identificação', text: 'MICROSCÓPIO ANÁLISE', risk_score: 32, risk_level: 'Low', contamination_count: 3, pathogen_types: { 'Aeróbios Mesófilos': 3 } },
        ];

        const areas = mockAreas.map(area => {
            const color = this.getRiskColor(area.risk_score, area.risk_level);
            return {
                ...area,
                fillColor: color.replace('1)', '0.7)'),
                strokeColor: '#fff',
                lineWidth: 3,
                preFillColor: color.replace('1)', '0.5)'),
            };
        });

        // Create a DETAILED SVG floor plan with rooms and labels (optimized for 100% zoom)
        const svgFloorPlan = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(`
            <svg xmlns="http://www.w3.org/2000/svg" width="1400" height="600" viewBox="0 0 1400 600">
                <!-- Background -->
                <rect width="1400" height="600" fill="#e8f4f8"/>
                
                <!-- Main building border -->
                <rect x="40" y="36" width="1320" height="528" fill="#ffffff" stroke="#2c3e50" stroke-width="3"/>
                
                <!-- Sala de Diluição (Norte) -->
                <rect x="60" y="60" width="420" height="216" fill="#e3f2fd" stroke="#1976d2" stroke-width="2"/>
                <text x="270" y="96" text-anchor="middle" font-size="16" font-weight="bold" fill="#1565c0">
                    SALA DE DILUIÇÃO (NORTE)
                </text>
                
                <!-- Sala de Leitura (NE) -->
                <rect x="920" y="60" width="420" height="216" fill="#f3e5f5" stroke="#7b1fa2" stroke-width="2"/>
                <text x="1130" y="96" text-anchor="middle" font-size="16" font-weight="bold" fill="#6a1b9a">
                    SALA DE LEITURA
                </text>
                
                <!-- Sala de Pesagem (Centro) -->
                <rect x="500" y="221" width="400" height="216" fill="#FFE0B2" stroke="#f57c00" stroke-width="3"/>
                <text x="700" y="257" text-anchor="middle" font-size="16" font-weight="bold" fill="#E65100">
                    SALA DE PESAGEM
                </text>
                
                <!-- Sala de Diluição (Sul) -->
                <rect x="60" y="336" width="420" height="216" fill="#e3f2fd" stroke="#1976d2" stroke-width="2"/>
                <text x="270" y="372" text-anchor="middle" font-size="16" font-weight="bold" fill="#1565c0">
                    SALA DE DILUIÇÃO (SUL)
                </text>
                
                <!-- Sala de Identificação (SE) -->
                <rect x="920" y="336" width="420" height="216" fill="#e8f5e9" stroke="#388e3c" stroke-width="2"/>
                <text x="1130" y="372" text-anchor="middle" font-size="16" font-weight="bold" fill="#2e7d32">
                    SALA DE IDENTIFICAÇÃO
                </text>
                
                <!-- Legend info -->
                <text x="67" y="588" font-size="12" fill="#666">
                    ⚠️ Mock Data: Click on colored circles to see risk details
                </text>
            </svg>
        `)}`;

        console.log('✅ Mock data generated:', {
            areasCount: areas.length,
            svgLength: svgFloorPlan.length,
            mockFloorsCount: mockFloors.length,
            svgPreview: svgFloorPlan.substring(0, 100)
        });

        // FORCE set state - don't let anything override this, mas só se componente ainda estiver montado
        if (this._isMounted) {
            this.setState({
                areas,
                floorPlanImage: svgFloorPlan,
                floorId: 'mock-floor-1',
                mockFloors: mockFloors,
                loading: false,
                error: '⚠️ Using Mock Data - No floors configured in database yet. Import data using import_excel_data.py'
            }, () => {
                if (this._isMounted) {
                    console.log('✅✅✅ State FORCED with mock data:', {
                        areasInState: this.state.areas.length,
                        floorPlanImageExists: !!this.state.floorPlanImage,
                        floorPlanImageType: this.state.floorPlanImage ? this.state.floorPlanImage.substring(0, 50) : 'NULL',
                        loading: this.state.loading,
                        floorId: this.state.floorId
                    });
                }
            });
        }
    }

    loadHeatMapData = async () => {
        const { floorId, riskType, periodDays } = this.state;

        if (!floorId) return;

        this.setState({ loading: true, error: null, selectedArea: null });

        try {
            const riskResponse = await Axios.instance.get('risk/heatmap/', {
                params: { floor_id: floorId, risk_type: riskType, period_days: periodDays }
            });

            const floorResponse = await Axios.instance.get(`floors/${floorId}/`);

            const heatmapData = riskResponse.data.heatmap_data || [];
            const areas = heatmapData.map(location => {
                const color = this.getRiskColor(location.risk_score, location.risk_level);
                const rectCoords = location.rect_coordinates ?
                    location.rect_coordinates.split(',').map(Number) : null;
                const polyCoords = location.coordinates ?
                    location.coordinates.split(',').map(Number) : null;

                let shape, coords;
                if (rectCoords && rectCoords.length === 4) {
                    shape = 'rect';
                    coords = rectCoords;
                } else if (polyCoords && polyCoords.length >= 6) {
                    shape = 'poly';
                    coords = polyCoords;
                } else {
                    return null;
                }

                return {
                    id: location.location_id,
                    shape,
                    coords,
                    fillColor: color.replace('1)', '0.6)'),
                    preFillColor: color.replace('1)', '0.4)'),
                    strokeColor: '#ffffff',
                    lineWidth: 2,
                    name: location.room_name,
                    text: location.location_name,
                    risk_score: location.risk_score,
                    risk_level: location.risk_level,
                    contamination_count: location.contamination_count,
                    pathogen_types: location.pathogen_types
                };
            }).filter(Boolean);

            this.setState({
                areas,
                floorPlanImage: floorResponse.data.floor_plan,
                floorPlanWidth: floorResponse.data.floor_plan_width || 856,
                loading: false
            });
        } catch (error) {
            console.error('❌ Error loading heatmap:', error);
            if (this._isMounted) {
                this.setState({ loading: false, error: 'Error loading heatmap data' });
            }
        }
    };

    getRiskColor = (score, level) => {
        switch (level) {
            case 'Critical': return 'rgba(220, 20, 60, 1)';
            case 'High': return 'rgba(255, 99, 71, 1)';
            case 'Medium': return 'rgba(255, 215, 0, 1)';
            case 'Low': return 'rgba(50, 205, 50, 1)';
            default: return 'rgba(144, 238, 144, 1)';
        }
    };

    handleAreaClick = (area) => {
        this.setState({ selectedArea: area });
    };

    handleAreaHover = (area, index, event) => {
        this.setState({ hoveredArea: area });
    }

    handleAreaLeave = () => {
        this.setState({ hoveredArea: null });
    }

    handleFilterChange = (e) => {
        const { name, value } = e.target;

        if (this._isMounted) {
            this.setState({ [name]: value }, () => {
                if (this._isMounted && this.state.floorId) {
                    this.loadHeatMapData();
                    if (name === 'floorId' && this.props.onFloorChange) {
                        this.props.onFloorChange(this.state.floorId);
                    }
                }
            });
        }
    };
    render() {
        const { floorId, areas, floorPlanImage, riskType, periodDays, loading, selectedArea, hoveredArea, error, mockFloors } = this.state;
        const { t } = this.props;
        const floors = (this.props.floorsList && this.props.floorsList.length > 0) ? this.props.floorsList : mockFloors;

        const filteredAreas = areas.filter(area => {
            if (riskType === 'frequency') return ['High', 'Critical'].includes(area.risk_level);
            if (riskType === 'severity') return area.risk_level === 'Medium';
            return true;
        });

        return (
            <div style={{ width: '100%', padding: '0 8px' }}>

                {/* Linha de controles */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-end',
                    gap: '16px',
                    marginBottom: '10px',
                    flexWrap: 'wrap',
                    background: '#fff',
                    padding: '10px 14px',
                    borderRadius: '8px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
                }}>
                    <FormGroup style={{ margin: 0 }}>
                        <Label for="floorId" style={{ fontSize: '12px', fontWeight: 600, color: '#555', display: 'block', marginBottom: '3px' }}>
                            {t('locations.floor')}
                        </Label>
                        <Input
                            type="select"
                            name="floorId"
                            id="floorId"
                            value={floorId || ''}
                            onChange={this.handleFilterChange}
                            style={{ fontSize: '13px', padding: '4px 8px', height: '32px', minWidth: '200px' }}
                        >
                            <option value="">{t('riskManagement.selectFloor')}</option>
                            {floors.map(floor => (
                                <option key={floor.id} value={floor.id}>
                                    {floor.building?.building_name || t('locations.building')} - {floor.floor_name}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>

                    <FormGroup style={{ margin: 0 }}>
                        <Label for="periodDays" style={{ fontSize: '12px', fontWeight: 600, color: '#555', display: 'block', marginBottom: '3px' }}>
                            {t('common.filter')}
                        </Label>
                        <Input
                            type="select"
                            name="periodDays"
                            id="periodDays"
                            value={periodDays}
                            onChange={this.handleFilterChange}
                            style={{ fontSize: '13px', padding: '4px 8px', height: '32px' }}
                        >
                            <option value="30">Last 30 days</option>
                            <option value="90">Last 90 days</option>
                            <option value="180">Last 180 days</option>
                        </Input>
                    </FormGroup>

                    <FormGroup style={{ margin: 0 }}>
                        <Label style={{ fontSize: '12px', fontWeight: 600, color: '#555', display: 'block', marginBottom: '3px' }}>
                            {t('riskManagement.riskLevel')}
                        </Label>
                        {/* ButtonGroup — botões com estado visível */}
                        <ButtonGroup size="sm">
                            {[
                                { value: 'total', label: t('common.total') },
                                { value: 'frequency', label: t('riskManagement.highRisk') },
                                { value: 'severity', label: t('riskManagement.mediumRisk') }
                            ].map(({ value, label }) => (
                                <Button
                                    key={value}
                                    onClick={() => this.handleFilterChange({ target: { name: 'riskType', value } })}
                                    style={{
                                        backgroundColor: riskType === value ? '#0056b3' : '#dee2e6',
                                        borderColor: riskType === value ? '#0056b3' : '#ced4da',
                                        color: riskType === value ? '#fff' : '#495057',
                                        fontWeight: riskType === value ? 700 : 500,
                                        fontSize: '13px',
                                        padding: '4px 12px'
                                    }}
                                >
                                    {label}
                                </Button>
                            ))}
                        </ButtonGroup>
                    </FormGroup>
                </div>

                {/* Legenda */}
                <div style={{ display: 'flex', gap: '16px', marginBottom: '10px', fontSize: '12px', alignItems: 'center', paddingLeft: '4px' }}>
                    {[
                        { color: 'rgba(255,99,71,0.75)', label: 'High' },
                        { color: 'rgba(255,215,0,0.85)', label: 'Medium' },
                        { color: 'rgba(50,205,50,0.75)', label: 'Low' }
                    ].map(({ color, label }) => (
                        <span key={label} style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#444' }}>
                            <span style={{
                                width: '12px', height: '12px',
                                borderRadius: '3px',
                                backgroundColor: color,
                                display: 'inline-block',
                                border: '1px solid rgba(0,0,0,0.1)'
                            }} />
                            {label}
                        </span>
                    ))}
                </div>

                {/* Container do mapa — largura total */}
                <div
                    ref={node => {
                        this.containerRef = node;
                        if (node && this.resizeObserver) {
                            this.resizeObserver.observe(node);
                        }
                    }}
                    style={{
                        width: '100%',
                        position: 'relative',
                        minHeight: '400px',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef',
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start'
                    }}
                >
                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px', gap: '10px' }}>
                            <Spinner /> <span style={{ color: '#666' }}>Loading...</span>
                        </div>
                    ) : floorPlanImage ? (
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                            <ImageMapper
                                src={floorPlanImage}
                                map={{ name: 'risk-map', areas: filteredAreas }}
                                width={this.state.containerWidth || 900}
                                imgWidth={856}
                                onClick={this.handleAreaClick}
                                onMouseEnter={this.handleAreaHover}
                                onMouseLeave={this.handleAreaLeave}
                            />
                            {/* Bolhas de risco sobrepostas */}
                            <svg
                                style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }}
                                width={this.state.containerWidth || 900}
                                height="100%"
                            >
                                {filteredAreas.map(area => {
                                    const scale = (this.state.containerWidth || 900) / 856;
                                    let cx, cy;
                                    if (area.shape === 'rect') {
                                        cx = ((area.coords[0] + area.coords[2]) / 2) * scale;
                                        cy = ((area.coords[1] + area.coords[3]) / 2) * scale;
                                    } else {
                                        const xs = area.coords.filter((_, i) => i % 2 === 0);
                                        const ys = area.coords.filter((_, i) => i % 2 !== 0);
                                        cx = (xs.reduce((a, b) => a + b, 0) / xs.length) * scale;
                                        cy = (ys.reduce((a, b) => a + b, 0) / ys.length) * scale;
                                    }
                                    const score = area.risk_score || 0;
                                    const radius = Math.max(10, Math.min(50, score * 0.5));
                                    const color = this.getRiskColor(score, area.risk_level);
                                    return (
                                        <circle
                                            key={area.id}
                                            cx={cx}
                                            cy={cy}
                                            r={radius}
                                            fill={color.replace('1)', '0.45)')}
                                            stroke={color.replace('1)', '0.9)')}
                                            strokeWidth={2}
                                        />
                                    );
                                })}
                            </svg>
                        </div>
                    ) : (
                        <div style={{ padding: '40px', textAlign: 'center', color: '#999' }}>
                            <p style={{ fontSize: '16px' }}>Nenhuma planta disponível</p>
                        </div>
                    )}

                    {hoveredArea && (
                        <div style={{
                            position: 'absolute',
                            top: hoveredArea.coords[1],
                            left: hoveredArea.coords[0] + 25,
                            background: 'white',
                            padding: '5px 8px',
                            borderRadius: '4px',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
                            fontSize: '12px',
                            pointerEvents: 'none',
                            zIndex: 10,
                            border: '1px solid #e0e0e0'
                        }}>
                            <strong>{hoveredArea.name}</strong><br />
                            Score: {hoveredArea.risk_score?.toFixed(2)}
                        </div>
                    )}
                </div>

                {/* Painel de detalhes ao clicar */}
                {selectedArea && (
                    <div style={{
                        position: 'fixed', top: '80px', right: '20px',
                        width: '260px',
                        zIndex: 1000,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                        borderRadius: '12px',
                        backgroundColor: 'white',
                        overflow: 'hidden'
                    }}>
                        <div style={{ padding: '14px 16px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                                <h5 style={{ fontSize: '14px', fontWeight: 600, color: '#2c3e50', margin: 0 }}>
                                    {selectedArea.name}
                                </h5>
                                <button
                                    onClick={() => this.setState({ selectedArea: null })}
                                    style={{ background: 'none', border: 'none', fontSize: '16px', cursor: 'pointer', color: '#666', lineHeight: 1, padding: 0 }}
                                >✕</button>
                            </div>

                            <div style={{ marginBottom: '8px' }}>
                                <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '2px' }}>{t('riskManagement.location')}</div>
                                <div style={{ fontSize: '13px', wordBreak: 'break-word' }}>{selectedArea.text}</div>
                            </div>

                            <div style={{ marginBottom: '8px' }}>
                                <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '2px' }}>{t('riskManagement.riskScore')}</div>
                                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#007bff' }}>
                                    {selectedArea.risk_score?.toFixed(2)}/100
                                </div>
                            </div>

                            <div style={{ marginBottom: '8px' }}>
                                <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '4px' }}>{t('riskManagement.riskLevel')}</div>
                                <span className={`badge badge-${selectedArea.risk_level?.toLowerCase()}`}
                                    style={{ fontSize: '12px', padding: '4px 10px' }}>
                                    {selectedArea.risk_level}
                                </span>
                            </div>

                            <div style={{ marginBottom: '8px' }}>
                                <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '2px' }}>{t('riskManagement.contaminations')}</div>
                                <div style={{ fontSize: '16px', fontWeight: 600 }}>{selectedArea.contamination_count || 0}</div>
                            </div>

                            {selectedArea.pathogen_types && Object.keys(selectedArea.pathogen_types).length > 0 && (
                                <div style={{ paddingTop: '8px', borderTop: '1px solid #e9ecef' }}>
                                    <div style={{ fontSize: '11px', color: '#6c757d', marginBottom: '6px' }}>
                                        {t('results.pathogen')} {t('results.detected')}
                                    </div>
                                    <ul style={{ margin: 0, paddingLeft: '14px', fontSize: '12px' }}>
                                        {Object.entries(selectedArea.pathogen_types).map(([pathogen, count]) => (
                                            <li key={pathogen}><strong>{pathogen}:</strong> {count}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {error && (
                    <div className="alert alert-warning" style={{ marginTop: '12px', fontSize: '12px' }}>{error}</div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    floorsList: state.floorsListReducer
});

export default connect(mapStateToProps, { fetchFloors })(withTranslation()(RiskHeatMap));